<template>
  <b-modal
    :active.sync="isActive"
    :full-screen="true"
  >
    <div class="card">
      <div class="login-modal-card">
        <div class="login-buttons-card" v-if="!user.uid">
          <h1 style="margin-top: 80px;">{{ $t(`${translationPath}.loginIn`) }}</h1>
          <div class="google-btn"  @click="signInEvent('google')">
            <div class="google-icon-wrapper">
              <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
            </div>
            <p class="btn-text"><b>{{ $t(`${translationPath}.googleSignIn`) }}</b></p>
          </div>
          <div>
            <a class="button button--social-login button--github" @click="signInEvent('github')">
              <font-awesome-icon style="margin-right: 10px;"
                size="lg" :icon="['fab', 'github']" />{{ $t(`${translationPath}.githubLogin`) }}</a>
          </div>
          <div style="margin-top: 20px;">
            <a class="button button--social-login button--github"
              style="width: 192px;" @click="logInAnonEvent()">
              <font-awesome-icon style="margin-right: 10px;"
                size="lg" :icon="['fas', 'user-lock']" />Login later</a>
          </div>
        </div>
        <div
          v-if="user.uid"
          class="user-card"
        >
          <h2
            style="margin-top: 80px;"
            v-if="user.isAnonymous"
          >{{ $t(`${translationPath}.youAreAnonim`) }}</h2>
          <!-- <button @click="changeToNormalAccount">Authent</button> -->
          <div
            class="avatar"
            v-if="user.photoURL"
            :style="{ 'background-image': 'url(' + user.photoURL + ')' }"
          ></div>
          <h2>
            {{ user.email }}
          </h2>
          <button
            @click="logOutUserEvent"
            class="logout-button"
          >
            {{ $t(`${translationPath}.logout`) }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { signIn, logInAnon, mergeAnonimousAccount } from '../mixins/firebase';

export default {
  name: 'LoginModal',
  data() {
    return {
      translationPath: 'account',
      isDev: false,
    };
  },
  mounted() {
    this.isDev = window.location.origin.includes('dev--SuperDaily.netlify') || window.location.origin.includes('localhost');
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
      displayLoginModal: (state) => state.userStore.displayLoginModal,
    }),
    isActive: {
      get() {
        return this.displayLoginModal;
      },
      set(value) {
        this.setLoginModalDisplay(value);
      },
    },
  },
  methods: {
    changeToNormalAccount() {
      mergeAnonimousAccount();
    },
    signIn,
    logInAnon,
    ...mapActions({
      logOutUser: 'userStore/logOutUser',
      logInAnonUser: 'userStore/logInAnonUser',
      setLoginModalDisplay: 'userStore/setLoginModalDisplay',
    }),
    logOutUserEvent() {
      this.logOutUser();
      this.isActive = false;
    },
    signInEvent(app) {
      this.signIn(app).then(() => console.log('log'));
    },
    logInAnonEvent() {
      this.$buefy.dialog.confirm({
        title: this.$t(`${this.translationPath}.anonimLoginModalTitle`),
        confirmText: this.$t(`${this.translationPath}.anonimLoginModalConfirm`),
        cancelText: this.$t(`${this.translationPath}.anonimLoginModalCancel`),
        message: this.$t(`${this.translationPath}.anonimLoginModalMessage`),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.logInAnon(),
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  height: 100vh;
  background: $background-light-color;
  border-radius: 0px!important;
  text-align: center;
}
.user-card {
  padding-top: 20px;
}
.avatar {
  width: 60px;
  height: 60px;
  border-radius: 60px;
  background-size: cover;
  margin: 30px auto;
}
.logout-button {
  margin-top: 20px;
  border-radius: 20px;
  padding: 10px 30px;
  border: 1px solid #569783;
  background: #569783;
  color: $font-light-color;
  font-weight: 600;
  font-size: 14px;
}
.login-buttons-card {
  padding-top: 30px;
  button {
    padding: 10px 40px;
    border-radius: 20px;
    font-weight: 700;
    margin-top: 20px;
  }
  h1 {
    font-weight: 700;
    font-size: 22px;
  }
}
.button-google {
  background: #569783;
  border: 1px solid #569783;
  color: $font-light-color;
}
.button-annon {
  background: wheat;
  border: 1px solid wheat;
}
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn {
  width: 195px;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  margin: 20px auto;
  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $background-light-color;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: -8px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    float: right;
    margin: 14px 11px 0 0;
    color: $font-light-color;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
  }
  &:active {
    background: $button-active-blue;
  }
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);

</style>
